import { swSettings } from "app/common/services/swSettings";
import { BasicDurations } from "app/services/DurationService";
import categoryService from "app/common/services/categoryService";

const DEFAULT_DURATION = BasicDurations.LAST_MONTH;

export const hasEnrichedCustomIndustryPermission = (): boolean => {
    return swSettings.allowedDuration(DEFAULT_DURATION) && categoryService.hasAdvancedCustomIndustriesPermission();
};
